module.exports = __webpack_public_path__ + "assets/img/rjsa2.4828026c.png";